import lightThemeColors from '@prisjakt/design-tokens/light-theme-colors.json';
import { colors } from '../variables';
import { setRgbaAlpha } from '../../src/color-utils';

const theme = {
  colors: {
    ...lightThemeColors,
  },
  bg: {
    primary: colors.white,
    secondary: colors.semiWhite,
    overlay: setRgbaAlpha(colors.darkBlue1, '0.2'), // darkBlue1 with 20% opacity,
    productCompare: colors.yellow3,
    productCompareLight: setRgbaAlpha(colors.yellow3, '0.05'),
  },
  header: {
    bg: colors.lightTheme.maybeBlue500,
    fg: colors.lightTheme.base100,
  },
  footer: {
    bg: {
      primary: colors.lightTheme.base100,
      secondary: colors.lightTheme.base100,
    },
    fg: {
      primary: colors.lightTheme.base600,
    },
  },
  lines: {
    primary: colors.lightGray1,
    secondary: colors.lightGray2,
    tertiary: colors.darkGray1,
    quaternary: colors.darkBlue1,
    highlight: colors.lightBlue3,
    groupHeader: colors.yellow3,
  },
  text: {
    primary: colors.darkBlue1,
    secondary: colors.darkGray4,
    tertiary: colors.darkGray2,
    quaternary: colors.mediumGray1,

    linkExternal: colors.lightBlue3,
    linkExternalHover: colors.lightTheme.maybeBlue500,
    linkInternal: colors.darkBlue1,
    linkInternalHover: colors.darkBlue2,
    callToAction: colors.lightBlue3,
    callToActionHover: colors.lightTheme.maybeBlue500,
    negative: colors.red1,
    positive: colors.green1,
  },
  icons: {
    primary: colors.darkGray4,
    secondary: colors.darkGray2,
    tertiary: colors.mediumGray1,
    quaternary: colors.lightGray2,
    light: colors.mediumGray2,
    callToAction: colors.lightBlue3,
    callToActionHover: colors.lightTheme.maybeBlue500,
    positive: colors.green1,
    negative: colors.red1,
  },
  buttons: {
    primary: {
      bg: colors.lightBlue3,
      bgActive: colors.lightTheme.maybeBlue100,
      text: colors.white,
      textHover: colors.white,
    },
    secondary: {
      bg: colors.darkGray2,
      text: colors.white,
      textHover: colors.white,
    },
    tertiary: {
      bg: colors.lightGray1,
      text: colors.darkBlue1,
      textHover: colors.darkBlue1,
    },
    quarternary: {
      bg: colors.darkBlue1,
      text: colors.white,
      textHover: colors.white,
    },
    positive: {
      bg: colors.darkGreen1,
      text: colors.white,
      textHover: colors.white,
    },
    negative: {
      bg: colors.red1,
      text: colors.white,
      textHover: colors.white,
    },
    link: {
      bg: 'transparent',
      text: colors.lightBlue3,
      textHover: colors.lightTheme.maybeBlue500,
    },
    disabled: {
      bg: colors.darkGray1,
      text: colors.white,
      textHover: colors.white,
    },
    category: {
      bg: colors.white,
      bgActive: setRgbaAlpha(colors.lightBlue3, '0.08'),
      text: colors.darkBlue1,
      textHover: colors.lightBlue3,
    },
    panning: {
      bg: 'rgba(0, 0, 0, 0.6)',
      bgHover: 'rgba(0, 0, 0, 0.4)',
      text: colors.white,
    },
  },
  pill: {
    primary: {
      bg: colors.lightBlue3,
      text: colors.white,
    },
    inverted: {
      bg: colors.white,
      text: colors.darkBlue1,
    },
  },
  inputs: {
    primary: {
      bg: colors.white,
      border: colors.darkGray1,
      borderFocus: colors.lightBlue2,
    },
  },
  dropdowns: {
    primary: {
      bg: colors.white,
      hoverBackground: setRgbaAlpha(colors.lightBlue3, '0.2'),
      borderRadius: '5px',
      borderColor: {
        active: colors.darkBlue1,
        inactive: colors.darkBlue1,
      },
    },
    secondary: {
      bg: colors.white,
      hoverBackground: setRgbaAlpha(colors.lightBlue3, '0.2'),
      borderRadius: 0,
      borderColor: {
        active: colors.lightGray1,
        inactive: 'transparent',
      },
    },
  },
  placeholders: {
    bg: colors.semiWhite,
    fg: colors.lightGray2,
  },
  cookieBanner: {
    bg: setRgbaAlpha(colors.darkBlue1, '0.9'),
    fg: colors.white,
  },
  actionBar: {
    bg: colors.darkBlue1,
    fg: colors.white,
    boxShadow: '0 -2px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  ratings: {
    positive: { bg: colors.green4, fg: colors.green3 },
    neutral: { bg: colors.yellow5, fg: colors.yellow4 },
    negative: { bg: colors.red4, fg: colors.red3 },
    disabled: { bg: colors.lightGray1, fg: colors.darkGray2 },
  },
  notifications: {
    info: {
      bg: setRgbaAlpha(colors.lightBlue3, '0.04'),
      fg: colors.lightBlue3,
    },
    issue: {
      bg: setRgbaAlpha(colors.red4, '0.2'),
      fg: setRgbaAlpha(colors.red3, '0.7'),
    },
    neutral: {
      bg: colors.semiWhite,
      fg: colors.darkGray4,
    },
  },
  promos: {
    bg: setRgbaAlpha(colors.lightBlue1, 0.1),
    fg: colors.darkGray4,
  },
};

export type ThemeType = typeof theme & { layout?: string };

export default theme;
